import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { isDevLoginEnabled } from './devLogin';

type Props = {
  /** Optional. See RequireRole for the same dual-shape contract — layout
   *  route (`<Outlet/>`) when absent, direct wrap when present. */
  children?: ReactNode;
};

/**
 * Blocks a subtree to dev-login (QA/demo) sessions only. A real advisor
 * session — authenticated via the actual bmo_session cookie / ISAM SSO, not
 * the local dev-login bypass — is redirected to the advisor-entry error
 * page: spec §11 "Advisors — no dashboard", they arrive via BMO deep-link
 * into a specific workflow (bmo-workflow-platform-spec.md:439-443). See
 * docs/pretend-advisor.md swap-point #5.
 */
export function RequireDevLogin({ children }: Props) {
  if (!isDevLoginEnabled()) {
    return <Navigate to="/auth/error?cause=advisor-entry-required" replace />;
  }
  return children === undefined ? <Outlet /> : <>{children}</>;
}
